import { createFileRoute } from "@tanstack/react-router";
import { MembersScreen } from "./-settings/MembersScreen";

export const Route = createFileRoute("/$workspace/$project/settings/members")({
  staticData: { title: "Members" },
  component: MembersScreen,
});
